export const TYREHUB = 'hwt'
export const BATTERY = 'hte'
export const LUBRICANT = 'htl'
